export default "__VITE_ASSET__Bj$_O0Y$__"